import { Modal as AntModal } from "antd";
import { useTranslation } from "react-i18next";
import { EntTypesOfProduct } from "../../../../../models/handBooks/typeofproduct";
import {
  useAddProductCategoryMutation,
  useDeleteProductCategoryMutation,
  useEditProductCategoryMutation
} from "../../../../../redux/api/handBooksApi/chemicalization/productionCategory";

interface ProductCategoryRequest {
  id?: number;
  nameKy: string;
  nameRu: string;
  children?: Array<{
    nameKy: string;
    nameRu: string;
  }>;
}

export const useTypeOfCategory = (Modal: typeof AntModal, onSuccess: () => void) => {
  const { t } = useTranslation();
  const [addProductCategory] = useAddProductCategoryMutation();
  const [editProductCategory] = useEditProductCategoryMutation();
  const [deleteProductCategory] = useDeleteProductCategoryMutation();

  const onAddProductCategory = async (data: EntTypesOfProduct): Promise<boolean> => {
    try {
      console.log('Добавление категории:', data);
      const request: ProductCategoryRequest = {
        nameKy: data.nameKy || '',
        nameRu: data.nameRu || '',
        children: data.children || []
      };
      
      const response = await addProductCategory(request).unwrap();
      if (response.success) {
        onSuccess();
        return true;
      }
      return false;
    } catch (e: any) {
      Modal.error({
        title: t("msg.error"),
        content: e.data?.message ?? String(e.message),
      });
      return false;
    }
  };

  const onEditProductCategory = async (data: EntTypesOfProduct): Promise<boolean> => {
    try {
      console.log('Редактирование категории:', data);
      if (!data.id) {
        throw new Error('ID is required for editing');
      }

      const request: ProductCategoryRequest = {
        id: data.id,
        nameKy: data.nameKy || '',
        nameRu: data.nameRu || '',
        children: data.children || []
      };

      const response = await editProductCategory(request).unwrap();
      if (response.success) {
        onSuccess();
        return true;
      }
      return false;
    } catch (e: any) {
      Modal.error({
        title: t("msg.error"),
        content: e.data?.message ?? String(e.message),
      });
      return false;
    }
  };

  const onDeleteProductCategory = async (data: EntTypesOfProduct) => {
    if (!data.id) {
      Modal.error({
        title: t("msg.error"),
        content: "ID is required for deletion",
      });
      return;
    }

    Modal.confirm({
      title: t("general.modal_confirm"),
      content: t("msg.confirm_delete"),
      onOk: async () => {
        try {
          const response = await deleteProductCategory(data.id as number).unwrap();
          if (response.success) {
            onSuccess();
          }
        } catch (e: any) {
          Modal.error({
            title: t("msg.error"),
            content: e.data?.message ?? String(e.message),
          });
        }
      },
    });
  };

  return {
    onAddProductCategory,
    onEditProductCategory,
    onDeleteProductCategory,
  };
};
